/* Source: /app/components/ConversionEditor.cl.jac */
import {__jacJsx, __jacSpawn} from "@jac/runtime";
import { cn } from "../lib/utils.js";
import { Panel } from "./ui/Panel.js";
import { Editor } from "@monaco-editor/react";
import { useRef } from "react";
import { loadSyntax, configureTheme } from "../lib/syntax_highlighting.js";
import { useEffect } from "@jac/runtime";
function ConversionEditor(props) {
  let inputTitle = (props.inputTitle || "Input");
  let outputTitle = (props.outputTitle || "Output");
  let inputLanguage = (props.inputLanguage || "python");
  let outputLanguage = (props.outputLanguage || "python");
  let inputValue = (props.inputValue || "");
  let outputValue = (props.outputValue || "");
  let onInputChange = props.onInputChange;
  let className = (props.className || "");
  let onCodeRun = props.onCodeRun;
  let envReady = (props.envReady || false);
  let isDark = ((props.editorTheme === "vs-dark") || false);
  let inputEditorRef = useRef(null);
  let outputEditorRef = useRef(null);
  let monacoRef = useRef(null);
  async function handleOnMountIfJac(editor, monaco, lang) {
    if ((lang === "jac")) {
      let grammarConfig = await loadSyntax(monaco, editor);
      await configureTheme(monaco, grammarConfig, isDark);
    }
  }
  useEffect(() => {
    async function applyTheme() {
      if (!monacoRef.current) {
        return;
      }
      let monaco = monacoRef.current;
      if (((inputLanguage === "jac") && inputEditorRef.current)) {
        let grammarConfig = await loadSyntax(monaco, inputEditorRef.current);
        await configureTheme(monaco, grammarConfig, isDark);
      }
      if (((outputLanguage === "jac") && outputEditorRef.current)) {
        let grammarConfig = await loadSyntax(monaco, outputEditorRef.current);
        await configureTheme(monaco, grammarConfig, isDark);
      }
    }
    applyTheme();
  }, [props.editorTheme]);
  return __jacJsx("div", {"className": cn("h-full w-full grid grid-cols-2 gap-3", className)}, [__jacJsx(Panel, {"title": inputTitle, "className": "h-full", "showActions": true, "codeValue": inputValue, "onRun": onCodeRun, "envReady": envReady}, [__jacJsx(Editor, {"height": "100%", "width": "100%", "language": inputLanguage, "value": inputValue, "onChange": onInputChange, "theme": (((inputLanguage === "jac") && "jac-theme") || (props.editorTheme || "vs-light")), "onMount": (editor, monaco) => {
    inputEditorRef.current = editor;
    monacoRef.current = monaco;
    handleOnMountIfJac(editor, monaco, inputLanguage);
  }, "options": {"fontSize": 14, "minimap": {"enabled": false}, "scrollBeyondLastLine": false, "automaticLayout": true, "padding": {"top": 12}}}, [])]), __jacJsx(Panel, {"title": outputTitle, "className": "h-full", "showActions": true, "codeValue": outputValue, "onRun": onCodeRun, "envReady": envReady}, [__jacJsx(Editor, {"height": "100%", "width": "100%", "language": outputLanguage, "value": outputValue, "theme": (((outputLanguage === "jac") && "jac-theme") || (props.editorTheme || "vs-light")), "onMount": (editor, monaco) => {
    outputEditorRef.current = editor;
    monacoRef.current = monaco;
    handleOnMountIfJac(editor, monaco, outputLanguage);
  }, "options": {"fontSize": 14, "minimap": {"enabled": false}, "scrollBeyondLastLine": false, "automaticLayout": true, "readOnly": true, "padding": {"top": 12}}}, [])])]);
}
export {ConversionEditor};